// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  EVENTS: '/events',
  USER_PROFILE: '/user-profile',
  USER_ACCOUNT: '/user-account',
  COMPANY: '/company',
  COMPANY_PARTNER: '/company-partner',
  COMPANY_PROJECT: '/company-project',
  COMPANY_PROJECT_ACTION: '/company-project-action',
  COMPANY_MANAGMENT_DASHBOARD: '/company-managment-dashboard',
  USER_AFTER_LOGIN: '/user-after-login',
  COMPANY_PROJECT_CATEGORY: '/company-project-category',
  SUPPORT: '/support',
  ADMIN_SUPPORT: '/admin/support',
  REPORTS: '/reports',
};

// ----------------------------------------------------------------------

export const COMPANY_PARTNER_PATH = `${ROOTS.DASHBOARD}${ROOTS.COMPANY_PARTNER}`;
export const COMPANY_PROJECT_PATH = `${ROOTS.DASHBOARD}${ROOTS.COMPANY_PROJECT}`;
export const COMPANY_PROJECT_ACTION_PATH = `${ROOTS.DASHBOARD}${ROOTS.COMPANY_PROJECT_ACTION}`;
export const COMPANY_MANAGMENT_DASHBOARD_PATH = `${ROOTS.DASHBOARD}${ROOTS.COMPANY_MANAGMENT_DASHBOARD}`;
export const USER_AFTER_LOGIN_PATH = `${ROOTS.DASHBOARD}${ROOTS.USER_AFTER_LOGIN}`;
export const COMPANY_PROJECT_CATEGORY_PATH = `${ROOTS.DASHBOARD}${ROOTS.COMPANY_PROJECT_CATEGORY}`;

export const paths = {
  home: '/',
  changelog: 'https://docs.minimals.cc/changelog',
  pricing: '/pricing',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  termsOfService: '/terms-of-service',
  privacyPolicy: '/privacy-policy',
  page404: '/404',
  help: '/help',
  // DASHBOARD
  dashboard: {
    index: ROOTS.DASHBOARD,
    events: {
      index: ROOTS.DASHBOARD + ROOTS.EVENTS,
      edit: (id: string) => `${ROOTS.DASHBOARD + ROOTS.EVENTS}/edit/${id}`,
      create: `${ROOTS.DASHBOARD + ROOTS.EVENTS}/create`,
    },
    users: {
      index: `${ROOTS.DASHBOARD}/users`,
    },
    roles: {
      index: `${ROOTS.DASHBOARD}/roles`,
    },
    custom_fields: {
      index: `${ROOTS.DASHBOARD}/settings/custom-fields`,
    },
    company_partner: {
      index: `${COMPANY_PARTNER_PATH}`,
      create: `${COMPANY_PARTNER_PATH}/create`,
      edit: (id: string) => `${COMPANY_PARTNER_PATH}/edit/${id}`,
    },
    company_project: {
      index: `${COMPANY_PROJECT_PATH}`,
      create: `${COMPANY_PROJECT_PATH}/create`,
      edit: (id: string) => `${COMPANY_PROJECT_PATH}/edit/${id}`,
      view: (id: string) => `${COMPANY_PROJECT_PATH}/view/${id}`,
    },
    company_project_category: {
      index: `${COMPANY_PROJECT_CATEGORY_PATH}`,
      create: `${COMPANY_PROJECT_CATEGORY_PATH}/create`,
      edit: (id: string) => `${COMPANY_PROJECT_CATEGORY_PATH}/edit/${id}`,
    },
    company_project_action: {
      index: `${COMPANY_PROJECT_ACTION_PATH}`,
      create: `${COMPANY_PROJECT_ACTION_PATH}/create`,
      edit: (id: string) => `${COMPANY_PROJECT_ACTION_PATH}/edit/${id}`,
    },
    company_management_dashboard: {
      index: `${COMPANY_MANAGMENT_DASHBOARD_PATH}`,
    },
    company_managment_dashboard: {
      index: `${COMPANY_MANAGMENT_DASHBOARD_PATH}`,
    },
    user_after_login: {
      index: `${USER_AFTER_LOGIN_PATH}`,
    },
    reports: {
      index: `${ROOTS.DASHBOARD}${ROOTS.REPORTS}`,
    },
  },

  // Events
  events: {
    index: ROOTS.EVENTS,
    search: `${ROOTS.EVENTS}/search`,
    view: (id: number | string) => `${ROOTS.EVENTS}/${id}`,
  },
  userAccount: {
    index: ROOTS.USER_ACCOUNT,
  },
  userProfile: {
    index: ROOTS.USER_PROFILE,
  },
  company: {
    index: ROOTS.COMPANY,
  },
  // Support Tickets (Customer)
  support: {
    tickets: {
      index: `${ROOTS.SUPPORT}/tickets`,
      detail: (id: string) => `${ROOTS.SUPPORT}/tickets/${id}`,
    },
  },
  // Support Tickets (Admin)
  admin: {
    support: {
      tickets: {
        index: `${ROOTS.ADMIN_SUPPORT}/tickets`,
        detail: (id: string) => `${ROOTS.ADMIN_SUPPORT}/tickets/${id}`,
      },
    },
  },
};
